import { render, staticRenderFns } from "./videoByLink.vue?vue&type=template&id=6020cbb3&scoped=true"
import script from "./videoByLink.vue?vue&type=script&lang=js"
export * from "./videoByLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6020cbb3",
  null
  
)

export default component.exports